import React from 'react';
import styled from 'styled-components';
import { Col, Ic3Dots, Text } from 'basic-ui-lib';
import IcFolder from 'modules/media/assets/icons/IcFolder';
import MenuAction from 'basic-ui-lib/components/MenuTabelAction';
import { IMediaItem } from 'modules/media/interfaces/api';
import EditNameModal from 'basic-ui-lib/components/Modal/EditNameModal';
import ModalConfirm from 'widgets/ModalConfirm';
import colors from 'basic-ui-lib/constants/colors';
import { useMediaMoreAction } from 'modules/media/services/hooks/useMediaMoreAction';

interface FolderCardProps {
  item: IMediaItem;
  onClick: () => void;
  length?: number;
  currentPath: string;
}
export const FolderCard = ({ item, onClick, length, currentPath }: FolderCardProps) => {
  const { getListMenu, handleMenuClick, modalConfirmRef, editNameModalRef } = useMediaMoreAction({currentPath});

  return (
    <Container>
      <MoreButton
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <MenuAction listMenu={getListMenu(item)} onClick={(menuItem) => handleMenuClick(menuItem, item)}>
          <Ic3Dots width={24} height={24}/>
        </MenuAction>
      </MoreButton>
      <Content onDoubleClick={onClick}>
        <IcFolder />
      </Content>
      <Col gap={4} width='100%' alignItems='center'>
        <Text ellipsis content_2 medium>
          {item.name}
        </Text>
        <Text caption_3 regular color='neutral.text.3'>
          {length} items
        </Text>
      </Col>
      <ModalConfirm ref={modalConfirmRef} />
      <EditNameModal ref={editNameModalRef} />
    </Container>
  );
};

const MoreButton = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 2;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.2s,
    visibility 0.2s;

  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${colors.neutral.bg[1]};

  &:hover {
    cursor: pointer;
  }
`;

const Container = styled.div`
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: relative;
  user-select: none; 
  
  &:hover ${MoreButton} {
    opacity: 1;
    visibility: visible;
  }
`;

const Content = styled.div`
  width: 131px;
  height: 131px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

